import styled from 'styled-components'

import {
  Text,
  Colors,
  Media,
  Spacing,
} from '@doordash/design-language'

export const Root = styled.section`
  min-height: 600px;
  background: #f4fdff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3rem 0 4rem;
  position: relative;
  overflow: hidden;

  ${Media.Desktop`
    min-height: 330px;
    padding: 0 1rem;
  `}

  ${Media.Mobile`
    min-height: 290px;
    background-size: cover;
  `}
`

export const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  &:after {
    content: '';
    height: 100%;
    width: 100%;
    background-image: radial-gradient(
      50% 123%,
      rgba(0, 0, 0, 0) 46%,
      rgba(0, 0, 0, 0.25) 100%
    );
    z-index: 1;
    display: block;

    ${Media.Desktop`
      background-image: radial-gradient(
        50% 123%,
        rgba(0, 0, 0, 0.25) 46%,
        rgba(0, 0, 0, 0) 100%
      );
    `}
  }
`

export const TextContainer = styled.div`
  max-width: ${Spacing.XLarge}rem;
  padding: ${Spacing.Small}px;
  z-index: 1;

  ${Media.WideScreen`
    padding-top: ${Spacing.XxxxLarge}px;
    max-width: ${Spacing.XLarge}rem;
    max-width: none;
    text-align: center;
    margin: 0 auto;
  `}

  ${Media.Mobile`
    text-align: left;
  `}
`

type ChildrenProps = {
  alignChildren: 'top' | 'center' | 'bottom'
}

export const ChildrenWrapper = styled.div`
  z-index: 0;
  margin-top: ${Spacing.XxxLarge}px;
  ${(props: ChildrenProps) => {
    return props.alignChildren === 'bottom' ? 'margin-bottom: 0.5rem' : null
  }};

  align-self: ${(props: ChildrenProps) => {
    if (props.alignChildren === 'top') {
      return 'flex-start'
    }
    if (props.alignChildren === 'center') {
      return 'center'
    }
    return 'flex-end'
  }};
`

export const CityState = styled(Text)`
  color: ${Colors.SystemTeal50};
`

export const Title = styled(Text)`
  color: ${Colors.SystemGrey80};
`

export const HeroContent = styled(Text)`
  color: ${Colors.SystemGrey60};
`
